import type * as API from '@trinity/chat/api/interfaces';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type { UseDownloaderOptions } from '@trinity/chat-components/containers/QueryDownloader/index.js';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/index.js';

type Params = API.Transcripts.DownloadTranscriptReport.Request;

export const useDownloadTranscriptReport = (params: Params, options: Omit<UseDownloaderOptions<API.Transcripts.DownloadTranscriptReport.Response>, 'queryKey' | 'queryFn'> = {}) => {

  const apiClient = useChatApiClient();

  return useQueryDownloader({
    queryKey: [
      `get:calls/transcripts/report`,
      params,
    ],
    queryFn: () => {
      return apiClient.transcripts.downloadTranscriptReport({
        format: params.format,
        transcriptId: params.transcriptId,
      });
    },
    downloaderOptions: {
      onResponse: res => ({
        type: 'websocket',
        value: res.key,
      }),
    },
    ...options,
  });
};